import {Card, CardBody, CardFooter, CardHeader, CardText, CardTitle} from "reactstrap";
import Skeleton from "react-loading-skeleton";

const ComplainItemLoader = () => {
    return (
        <Card className="blog-card blog rtl" style={{borderColor:"#b7b7b7"}}>
            <CardHeader className="complain-header" style={{backgroundColor:"#b7b7b7"}}>
                <Skeleton />
            </CardHeader>
            <CardBody>
                <CardTitle className="complain-title">
                    <h4><Skeleton /></h4>
                </CardTitle>
                <div className="card-text complain-info">
                    <div className="complain-user">
                        <Skeleton circle={true} height={50} width={50} />
                        <Skeleton  />
                    </div>
                </div>
                <CardText className="complain-text">
                    <Skeleton count={3} />
                </CardText>
            </CardBody>
            <CardFooter>
                <Skeleton count={1}/>
            </CardFooter>
        </Card>
    );
};

export default ComplainItemLoader;